var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"mt-3 smaller"},[_vm._v(" We use your data in line with our "),_c('a',{attrs:{"href":"https://www.youroverseashome.com/privacy-policy/","target":"_blank"}},[_vm._v("Privacy Policy")]),_vm._v(" which includes the potential consequences of third parties using your data. ")])
}]

export { render, staticRenderFns }